import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';

import { firebaseConfig } from '../config';

export const firebaseApp = initializeApp(firebaseConfig);
// const db = getFirestore(firebaseApp);
export const auth = getAuth(firebaseApp);

if (import.meta.env.VITE_GCP_TENANT_ID) {
  auth.tenantId = import.meta.env.VITE_GCP_TENANT_ID;
} else {
  throw new Error('Missing Tenant ID');
}

/*
 * Setup Emulators
 */
// if (import.meta.env.VITE_FIRESTORE_EMULATOR_ENABLE) {
//   connectFirestoreEmulator(db, import.meta.env.VITE_FIRESTORE_EMULATOR_HOST_DOMAIN, import.meta.env.VITE_FIRESTORE_EMULATOR_HOST_PORT);
// }

if (import.meta.env.VITE_AUTH_EMULATOR_ENABLE) {
  connectAuthEmulator(auth, import.meta.env.VITE_AUTH_EMULATOR_HOST);
}

// if (import.meta.env.VITE_STORAGE_EMULATOR_ENABLE) {
//   connectStorageEmulator(storage, import.meta.env.VITE_STORAGE_EMULATOR_HOST_DOMAIN, import.meta.env.VITE_STORAGE_EMULATOR_HOST_PORT);
// }
